exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-enter-active, .question-leave-active {\n  transition: transform .3s ease, opacity .3s ease;\n  transform: translateY(0);\n  opacity: 1;\n}\n.question-enter {\n  opacity: 0;\n  transform: translateY(-50%);\n}\n.question-leave-to {\n  opacity: 0;\n  transform: translateY(50%);\n}\r\n", ""]);

// exports
